<template>
    <table-ish>
        <table-ish-row-router-link
            v-for="notification in notifications"
            :key="notification.uuid"
            :to="{ path: notification.path }"
        >
            <table-ish-cell :wrap="true">
                {{ notification.title }}

                <template slot="secondary">
                    {{ notification.description }}
                </template>
            </table-ish-cell>

            <table-ish-cell
                :shrink="true"
                class="text-right"
            >
                {{ notification.created_at | moment('HH:mm') }}

                <template slot="secondary">
                    {{ notification.created_at | moment('D MMM YYYY') }}
                </template>
            </table-ish-cell>
        </table-ish-row-router-link>
    </table-ish>
</template>

<script>
    export default {
        props: {
            notifications: {
                type: Array,
                required: true
            }
        }
    }
</script>
